export const THREAD_POPOVER_WIDTH = 280;
